import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      fill: "#67459E"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12 6a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6m-1.667 3.333a1 1 0 1 1 0 2 1 1 0 0 1 0-2m.171 5.04a.67.67 0 0 1-.95.008.667.667 0 0 1 .007-.951l3.934-3.933a.666.666 0 1 1 .942.942zm3.163.294a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    }, null, -1)
  ])))
}
export default { render: render }